import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetServiceTechniciansQueryVariables = Types.Exact<{
  customerId: Types.Scalars['bigint']['input'];
}>;


export type GetServiceTechniciansQuery = { __typename?: 'query_root', drivers: Array<{ __typename?: 'drivers', id: number, status: string, tax_class: string, user?: { __typename?: 'users', id: number, display_name: string, avatar_url?: string | null, email?: string | null, phone?: string | null } | null }> };


export const GetServiceTechniciansDocument = gql`
    query getServiceTechnicians($customerId: bigint!) {
  drivers(
    where: {config: {_contains: {attributes: {mobility_service: true}}}, user: {users_usertocustomers: {customer_id: {_eq: $customerId}}, users_usertoroles: {roletype: {name: {_eq: "driver"}}}, active: {_eq: true}}}
    order_by: {user: {display_name: asc}}
  ) {
    id
    status
    tax_class
    user {
      id
      display_name
      avatar_url
      email
      phone
    }
  }
}
    `;

/**
 * __useGetServiceTechniciansQuery__
 *
 * To run a query within a React component, call `useGetServiceTechniciansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceTechniciansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceTechniciansQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetServiceTechniciansQuery(baseOptions: Apollo.QueryHookOptions<GetServiceTechniciansQuery, GetServiceTechniciansQueryVariables> & ({ variables: GetServiceTechniciansQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceTechniciansQuery, GetServiceTechniciansQueryVariables>(GetServiceTechniciansDocument, options);
      }
export function useGetServiceTechniciansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceTechniciansQuery, GetServiceTechniciansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceTechniciansQuery, GetServiceTechniciansQueryVariables>(GetServiceTechniciansDocument, options);
        }
// @ts-ignore
export function useGetServiceTechniciansSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetServiceTechniciansQuery, GetServiceTechniciansQueryVariables>): Apollo.UseSuspenseQueryResult<GetServiceTechniciansQuery, GetServiceTechniciansQueryVariables>;
export function useGetServiceTechniciansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceTechniciansQuery, GetServiceTechniciansQueryVariables>): Apollo.UseSuspenseQueryResult<GetServiceTechniciansQuery | undefined, GetServiceTechniciansQueryVariables>;
export function useGetServiceTechniciansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceTechniciansQuery, GetServiceTechniciansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceTechniciansQuery, GetServiceTechniciansQueryVariables>(GetServiceTechniciansDocument, options);
        }
export type GetServiceTechniciansQueryHookResult = ReturnType<typeof useGetServiceTechniciansQuery>;
export type GetServiceTechniciansLazyQueryHookResult = ReturnType<typeof useGetServiceTechniciansLazyQuery>;
export type GetServiceTechniciansSuspenseQueryHookResult = ReturnType<typeof useGetServiceTechniciansSuspenseQuery>;
export type GetServiceTechniciansQueryResult = Apollo.QueryResult<GetServiceTechniciansQuery, GetServiceTechniciansQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/mobileService/queries/getServiceTechnicians.query.gql}
 */
export async function getServiceTechnicians(
  variables: GetServiceTechniciansQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetServiceTechniciansQuery['drivers']>
export async function getServiceTechnicians(
  variables: GetServiceTechniciansQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetServiceTechniciansQuery>
export async function getServiceTechnicians(
  variables: GetServiceTechniciansQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetServiceTechniciansQuery['drivers'] | GetServiceTechniciansQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetServiceTechniciansQuery>(
    GetServiceTechniciansDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.drivers
}